const $ = window.jQuery;
const Subscribe = {

    init () {
        //ABONNMENT ANNUEL
        $(".pay_list").change(function() {
            var pathname = window.location.pathname;
            if(pathname == '/abonnement/'){
                if ($(this).val() == 1) {
                $(".annual_int_block .price").html("60€/an");
                $(".sub_annual_int").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=30321");
                } else if ($(this).val() > 2 && $(this).val() < 5) {
                $(".annual_int_block .price").html("76€/an");
                $(".sub_annual_int").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=30322");
                } else {
                $(".annual_int_block .price").html("81€/an");
                $(".sub_annual_int").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=30323");
                }
            }else if(pathname == '/tarif-special/'){
                if ($(this).val() == 1) {
                $(".annual_int_block .price").html("<del>60€/an</del>51€/an");
                $(".sub_annual_int").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=41585");
                } else if ($(this).val() > 2 && $(this).val() < 5) {
                $(".annual_int_block .price").html("<del>76€/an</del>64,60€/an");
                $(".sub_annual_int").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=41586");
                } else {
                $(".annual_int_block .price").html("<del>81€/an</del>68,85€/an");
                $(".sub_annual_int").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=41587");
                }
            }else{
                if ($(this).val() == 1) {
                $(".annual_int_block .price").html("60€/an");
                $(".sub_annual_int").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=40088");
                } else if ($(this).val() > 2 && $(this).val() < 5) {
                $(".annual_int_block .price").html("76€/an");
                $(".sub_annual_int").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=40090");
                } else {
                $(".annual_int_block .price").html("81€/an");
                $(".sub_annual_int").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=40091");
                }
            }
        });
        var synch = $(".pay_list").on('change', function() {
            synch.not(this).get(0).selectedIndex = this.selectedIndex;
        });
        $(".pay_list").val(1).trigger("change");
        //ABONNMENT TRIMESTRIELLE
        $(".pay_list").change(function() {
            if ($(this).val() == 1) {
                $(".monthly_int_block .price").show();
                $(".monthly_num_block .price").show();
                $(".sub_monthly_int").show();
                $(".sub_monthly_num").show();
                $(".monthly_int_block .ost").hide();
                $(".monthly_num_block .ost").hide();
            } else if (jQuery(this).val() > 2 && jQuery(this).val() < 5) {
                $(".monthly_int_block .price").hide();
                $(".monthly_num_block .price").hide();
                $(".sub_monthly_int").hide();
                $(".sub_monthly_num").hide();
                $(".monthly_int_block .ost").show();
                $(".monthly_num_block .ost").show();
               
            } else {
                $(".monthly_int_block .price").hide();
                $(".monthly_num_block .price").hide();
                $(".sub_monthly_int").hide();
                $(".sub_monthly_num").hide();
                $(".monthly_int_block .ost").show();
                $(".monthly_num_block .ost").show();
            }
        });
        $(".pay_list").val(1).trigger("change");


     
        $(".pay_list").change(function() {
            var pathname = window.location.pathname;
            if(pathname == '/abonnement/'){
              if ($(this).val() == 1) {
                $(".reabo-btn-int-se").show();
                $(".btn-center").show();
                $(".reabo-btn-int-ae-price").html("60€");
                $(".reabo-btn-int-ae-link").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=30321");
              } else if ($(this).val() > 2 && $(this).val() < 5) {
                $(".reabo-btn-int-ae-price").html("76€");
                $(".reabo-btn-int-se").hide();
                $(".btn-center").hide();
                $(".reabo-btn-int-ae-link").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=30322");
              } else {
                $(".btn-center").hide();
                $(".reabo-btn-int-se").hide();
                $(".reabo-btn-int-ae-price").html("81€");
                $(".reabo-btn-int-ae-link").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=30323");
              }
            }else{
              if ($(this).val() == 1) {
                $(".reabo-btn-int-se").show();
                $(".btn-center").show();
                $(".reabo-btn-int-ae-price").html("60€");
                $(".reabo-btn-int-ae-link").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=40088");
              } else if ($(this).val() > 2 && $(this).val() < 5) {
                $(".reabo-btn-int-ae-price").html("76€");
                $(".reabo-btn-int-se").hide();
                $(".btn-center").hide();
                $(".reabo-btn-int-ae-link").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=40090");
              } else {
                $(".btn-center").hide();
                $(".reabo-btn-int-se").hide();
                $(".reabo-btn-int-ae-price").html("81€");
                $(".reabo-btn-int-ae-link").attr("href", "https://www.8pieds6.com/panier/?add-to-cart=40091");
              }
            }
        });
        $(".pay_list").val(1).trigger("change");
        
        $(".pay_list").change(function() {
            if ( $(this).val() == 1) {
                $(".reabo-btn-num-se").show();
                $(".btn-center-reabo-num").show();
                $(".reabo-btn-num-ae").show();
            } else if ($(this).val() > 2 && $(this).val() < 5) {
                $(".reabo-btn-num-se").hide();
                $(".btn-center-reabo-num").hide();
                $(".reabo-btn-num-ae").show();
                
            } else {
                $(".reabo-btn-num-se").hide();
                $(".btn-center-reabo-num").hide();
                $(".reabo-btn-num-ae").show();
            }
        });
        $(".pay_list").val(1).trigger("change");
    },


};

export default Subscribe;

